export default __webpack_public_path__ + "static/media/TAXI2FLY.df319997.svg";